import {
  INITIAL_STATE_PASSENGER,
  REQUEST_FETCH_PASSENGERS,
  FETCH_PASSENGERS_SUCCESS,
  FETCH_PASSENGERS_ERROR,
} from "../../../actions/reservations/passenger/fetchPassengersByAgency";

const initialState = {
  passengers: [],
  fetching: false,
  message: "",
  error: "",
};

const passengerByAgencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_PASSENGER: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_PASSENGERS: {
      return {
        ...state,
        passengers: [],
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_SUCCESS: {
      return {
        ...state,
        passengers: action.passengers,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGERS_ERROR: {
      return {
        ...state,
        passengers: [],
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default passengerByAgencyReducer;
